<template>
  <div class="tag-page">
    <div class="page-hero">
      <van-nav-bar
        :title="title"
        left-arrow
        :border="false"
        @click-left="onClickLeft"
      />

      <div class="hero-card">
        <!-- <div class="hero-title">{{ title }}</div> -->
        <div class="hero-desc">{{ pageDesc }}</div>
        <div class="hero-meta">
          <span class="meta-pill">已选 {{ selectedTotalCount }} / 10</span>
          <span class="meta-pill subtle">{{ readonly ? '仅查看当前标签' : '支持系统标签与自定义标签' }}</span>
        </div>
      </div>
    </div>

    <div class="page-content">
      <div class="section-card">
        <div class="section-title">推荐标签</div>
        <div class="section-desc">{{ readonly ? '展示当前已选择的系统标签。' : '请选择最符合自身特点或期待对象特点的标签，最多可选 10 个。' }}</div>

        <div v-if="readonly && readonlyTagTexts.length === 0" class="empty-text">暂无已选系统标签</div>
        <div v-else class="tag-list">
          <div
            v-for="tag in readonly ? readonlyTagTexts : systemTags"
            :key="readonly ? `readonly-${tag}` : tag.id"
            class="tag-item"
            :class="{
              'tag-item-active': readonly ? true : isSelected(tag.id),
              'tag-item-readonly': readonly
            }"
            @click="readonly ? null : toggleTag(tag)"
          >
            {{ readonly ? tag : tag.tagName }}
          </div>
        </div>
      </div>

      <div v-if="!readonly" class="section-card custom-editor-card">
        <div class="section-title">自定义标签</div>
        <div class="section-desc">可补充系统标签中没有但你想表达的关键词，单个标签最多 10 个字。</div>

        <div class="custom-input-wrap">
          <input
            v-model="customTagName"
            class="custom-input"
            placeholder="请输入自定义标签（选填）"
            maxlength="10"
            @keyup.enter="addCustomTag"
          >
          <div class="add-btn" :class="{ 'add-btn-disabled': !customTagName.trim() }" @click="addCustomTag">添加</div>
        </div>
      </div>

      <div v-if="selectedCustomTags.length > 0" class="section-card">
        <div class="section-title">{{ readonly ? '自定义标签' : '已添加的自定义标签' }}</div>
        <div class="section-desc">{{ readonly ? '展示当前已添加的自定义标签。' : '点击标签可移除。' }}</div>

        <div class="tag-list">
          <div
            v-for="(tag, index) in selectedCustomTags"
            :key="`custom-${index}`"
            class="tag-item tag-item-custom"
            :class="{ 'tag-item-readonly': readonly }"
            @click="readonly ? null : removeCustomTag(index)"
          >
            {{ readonly ? tag : `${tag} ×` }}
          </div>
        </div>
      </div>
    </div>

    <div class="page-actions" :class="{ single: readonly }">
      <van-button round class="action-btn secondary" @click="onClickLeft">{{ readonly ? '返回' : '取消' }}</van-button>
      <van-button
        v-if="!readonly"
        round
        type="info"
        class="action-btn primary"
        :loading="loading"
        :disabled="loading"
        @click="handleSave"
      >{{ loading ? '保存中' : '保存' }}</van-button>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import { getAllTags, getMemberTags, savePersonalityTags, saveSpouseRequirementTags } from '@/api/user';

export default {
  data() {
    return {
      title: '选择标签',
      tagType: 1,
      systemTags: [],
      selectedTagIds: [],
      selectedCustomTags: [],
      customTagName: '',
      loading: false,
      memberId: '',
      readonly: false,
      readonlyTagTexts: []
    };
  },
  computed: {
    selectedTotalCount() {
      return this.selectedTagIds.length + this.selectedCustomTags.length;
    },
    pageDesc() {
      if (this.readonly) {
        return this.tagType === 1
          ? '查看会员当前选择的性格标签。'
          : '查看会员当前选择的择偶标签。';
      }
      return this.tagType === 1
        ? '完善个性标签，让资料展示更鲜明。'
        : '完善择偶标签，让匹配方向更清晰。';
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    isSelected(tagId) {
      return this.selectedTagIds.includes(tagId);
    },
    toggleTag(tag) {
      if (this.readonly) {
        return;
      }
      const index = this.selectedTagIds.indexOf(tag.id);
      if (index > -1) {
        this.selectedTagIds.splice(index, 1);
      } else {
        if (this.selectedTagIds.length + this.selectedCustomTags.length >= 10) {
          Toast.fail('最多选择10个标签');
          return;
        }
        this.selectedTagIds.push(tag.id);
      }
    },
    addCustomTag() {
      if (this.readonly) {
        return;
      }
      const name = this.customTagName.trim();
      if (name && !this.selectedCustomTags.includes(name)) {
        if (this.selectedTagIds.length + this.selectedCustomTags.length >= 10) {
          Toast.fail('最多选择10个标签');
          return;
        }
        this.selectedCustomTags.push(name);
        this.customTagName = '';
      }
    },
    removeCustomTag(index) {
      if (this.readonly) {
        return;
      }
      this.selectedCustomTags.splice(index, 1);
    },
    loadReadonlySelectedTags() {
      this.selectedTagIds = [];
      this.selectedCustomTags = [];
      this.readonlyTagTexts = [];
      try {
        const tags = JSON.parse(this.$route.query.selectedTags || '[]');
        if (Array.isArray(tags) && tags.length > 0) {
          tags.forEach(tag => {
            if (tag.isCustom || !tag.tagId) {
              if (tag.tagName) {
                this.selectedCustomTags.push(tag.tagName);
              }
            } else if (tag.tagName) {
              this.readonlyTagTexts.push(tag.tagName);
              this.selectedTagIds.push(tag.tagId);
            }
          });
        }
        if (this.readonlyTagTexts.length === 0 && this.selectedCustomTags.length === 0) {
          const selectedText = (this.$route.query.selectedText || '').trim();
          if (selectedText) {
            this.readonlyTagTexts = selectedText.split('、').filter(Boolean);
            this.selectedTagIds = this.readonlyTagTexts.map((_, index) => index + 1);
          }
        }
      } catch (error) {
        console.error('加载只读标签失败', error);
        const selectedText = (this.$route.query.selectedText || '').trim();
        if (selectedText) {
          this.readonlyTagTexts = selectedText.split('、').filter(Boolean);
          this.selectedTagIds = this.readonlyTagTexts.map((_, index) => index + 1);
        }
      }
    },
    async loadSystemTags() {
      try {
        const res = await getAllTags();
        if (res.code === 20000) {
          this.systemTags = res.data;
        }
      } catch (error) {
        console.error('加载标签失败', error);
      }
    },
    async loadMemberTags() {
      try {
        this.selectedTagIds = [];
        this.selectedCustomTags = [];
        const res = await getMemberTags(this.memberId);
        if (res.code === 20000 && res.data) {
          const tags = this.tagType === 1 ? res.data.personalityTags : res.data.spouseRequirementTags;
          if (tags && tags.length > 0) {
            tags.forEach(tag => {
              if (tag.isCustom) {
                this.selectedCustomTags.push(tag.tagName);
              } else if (tag.tagId) {
                this.selectedTagIds.push(tag.tagId);
              }
            });
          }
        }
      } catch (error) {
        console.error('加载会员标签失败', error);
      }
    },
    loadLocalSelectedTags() {
      this.selectedTagIds = [];
      this.selectedCustomTags = [];
      try {
        const selectedTags = JSON.parse(localStorage.getItem('selectedTags') || '{}');
        const tags = this.tagType === 1 ? selectedTags.personalityTags : selectedTags.spouseRequirementTags;
        if (!tags || tags.length === 0) {
          return;
        }
        tags.forEach(tag => {
          if (tag.tagId) {
            this.selectedTagIds.push(tag.tagId);
          } else {
            const customTagName = tag.customTagName || tag.tagName;
            if (customTagName) {
              this.selectedCustomTags.push(customTagName);
            }
          }
        });
      } catch (error) {
        console.error('加载本地标签失败', error);
      }
    },
    async handleSave() {
      if (this.loading) return;

      if (this.selectedTagIds.length === 0 && this.selectedCustomTags.length === 0) {
        Toast.fail('请至少选择一个标签');
        return;
      }

      this.loading = true;
      try {
        if (!this.memberId) {
          const existingTags = JSON.parse(localStorage.getItem('selectedTags') || '{}');
          const tags = [];
          this.selectedTagIds.forEach(tagId => {
            const tag = this.systemTags.find(t => t.id === tagId);
            tags.push({ tagId: tagId, tagName: tag ? tag.tagName : '', customTagName: null });
          });
          this.selectedCustomTags.forEach(name => {
            tags.push({ tagId: null, tagName: name, customTagName: name });
          });
          if (this.tagType === 1) {
            existingTags.personalityTags = tags;
          } else {
            existingTags.spouseRequirementTags = tags;
          }
          localStorage.setItem('selectedTags', JSON.stringify(existingTags));
          Toast.success('保存成功');
          this.$router.go(-1);
          return;
        } else {
          localStorage.removeItem('selectedTags');
        }

        const tags = [];
        this.selectedTagIds.forEach(tagId => {
          tags.push({ tagId: tagId, customTagName: null });
        });
        this.selectedCustomTags.forEach(name => {
          tags.push({ tagId: null, customTagName: name });
        });

        const data = {
          memberInfoId: this.memberId,
          tags: tags
        };

        const api = this.tagType === 1 ? savePersonalityTags : saveSpouseRequirementTags;
        const res = await api(data);

        if (res.code === 20000) {
          Toast.success('保存成功');
          this.$router.replace({
            path: '/editInfos',
            query: { tab: this.tagType === 2 ? 'spouse' : 'basic' }
          });
        } else {
          Toast.fail(res.message || '保存失败');
        }
      } catch (error) {
        Toast.fail('保存失败');
        console.error('保存标签失败', error);
      } finally {
        this.loading = false;
      }
    }
  },
  created() {
    this.tagType = parseInt(this.$route.query.tagType || '1');
    this.title = this.tagType === 1 ? '我是这样的人' : '我想找这样的人';
    this.memberId = this.$route.query.memberId || '';
    this.readonly = this.$route.query.readonly === '1';

    this.loadSystemTags();
    if (this.readonly) {
      this.loadReadonlySelectedTags();
    } else if (this.memberId) {
      this.loadMemberTags();
    } else {
      this.loadLocalSelectedTags();
    }
  }
};
</script>

<style lang="less" src="../style/tagSelector.less" />



// WEBPACK FOOTER //
// src/views/tagSelector.vue